import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Material
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// Components
import Input from '../../../../components/inputs/input';

const EditDetailModal = ({ detail, onSave, onClose, open }) => {
    const [quantity, setQuantity] = useState(detail.quantity);

    const handleSave = () => {
        onSave(detail.refId, { ...detail, quantity });
        onClose();
    }

    const handleNumberChange = (event) => {
        const num = Number.parseInt(event.target.value);
        if (!isNaN(num) && num >= 1)
            setQuantity(num);
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">
                {`Detalle ${detail.refId}`}
            </DialogTitle>
            <DialogContent style={{ minWidth: 430 }}>
                <Grid container direction='column' spacing={1}>
                    <Grid style={{ marginTop: 5 }}>
                        <Input
                            fullWidth
                            size='small'
                            name='quantity'
                            label='Cantidad'
                            onChange={handleNumberChange}
                            value={quantity} 
                            type='number'
                            inputProps={{
                                min: '1',
                              }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={onClose} 
                    color="primary"
                >
                    Cancelar
                </Button>
                <Button 
                    onClick={handleSave} 
                    color="primary" 
                    variant='outlined'
                    autoFocus
                >
                    Guardar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

EditDetailModal.defaultProps = {
    onSave: () => {},
    onClose: () => {}
}

EditDetailModal.prototype = {
    onSave: PropTypes.func,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    detail: PropTypes.object
}

export default EditDetailModal;